import { ReceiptItem } from 'typescript/apps/checkout_v3/components/order_summary/components/receipt_item';
import {
  OrderSummaryDiscountAdjustment,
  TOrderSummary,
} from 'typescript/types/api/solidshop';
import { useTranslation } from 'react-i18next';

export const ORDER_SUMMARY_DISCOUNT_TEST_ID = 'order-summary-discount';

type DiscountsProps = {
  orderSummaryData: TOrderSummary;
};

export const Discounts = ({ orderSummaryData }: DiscountsProps) => {
  const { t } = useTranslation();

  const { discounts } = orderSummaryData;

  if (discounts.length === 0) {
    return null;
  }

  return (
    <>
      {discounts.map((discount, index) => (
        <div key={index} data-testid={ORDER_SUMMARY_DISCOUNT_TEST_ID}>
          <ReceiptItem
            label={t('checkout.receipt.label.v3.promoCode', {
              code: discount.name,
            })}
            cost={
              discount.adjustments.reduce(
                (acc: number, adj: OrderSummaryDiscountAdjustment) =>
                  acc + Number.parseFloat(adj.amount),
                0,
              ) as number
            }
            currency={discount.currency}
            negativeZero={true}
          />
        </div>
      ))}
    </>
  );
};
